<app-header></app-header>

<div class="wrapper">

  <app-estimate-box [isLoader]="isLoader"
    [submitBtnLabel]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'"
    (submitBtnClick)="saveInteriorData(historyState.isPaymentDone ? 'submit' : 'skip')"
    (forwardClick)="saveInteriorData(null)" (backClick)="back()"></app-estimate-box>


  <div class="section_wrapper" style="margin-top: 20px;">
    <!-- stepper component -->
    <div class="dashBoard interior_wrap">
      <app-stepper currentIndex="1.4" class="stepper"></app-stepper>
      <div class="interior_details w_100">
        <div class="interior_details_form">
          <h3 class="font_40_a32">Interior</h3>
          <div class=" form_section">
            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Appliances</mat-label>
              <mat-chip-grid #chipGrid aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let item of Appliances" (removed)="remove(item)">
                  {{item}}
                  <button matChipRemove [attr.aria-label]="'remove ' + item">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #applianceInput [formControl]="roomCtrl" [matChipInputFor]="chipGrid"
                [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="add($event)" />
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                <mat-option *ngFor="let item of filteredAppliances | async" [value]="item">
                  {{item}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="w_100 genericTextFiled_h60">
              <mat-label>Fireplaces</mat-label>
              <input matInput type="number" min="0" placeholder="" name="FireplacesTotal" [(ngModel)]=FireplacesTotal>
            </mat-form-field>

            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Interior Features</mat-label>
              <mat-chip-grid #chipAppGrid aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let interior of InteriorFeatures" (removed)="removeInteriorFeatures(interior)">
                  {{interior}}
                  <button matChipRemove [attr.aria-label]="'remove ' + interior">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #interiorFeatureInput [formControl]="interiorCtrl" [matChipInputFor]="chipAppGrid"
                [matAutocomplete]="autoInterior" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addInteriorFeatures($event)" />
              <mat-autocomplete #autoInterior="matAutocomplete" (optionSelected)="selectedInteriorFeatures($event)">
                <mat-option *ngFor="let interior of filteredInteriorFeatures | async" [value]="interior">
                  {{interior}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Heating</mat-label>
              <mat-chip-grid #chipHeatingGrid aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let heatingItems of Heating" (removed)="removeHeatingItems(heatingItems)">
                  {{heatingItems}}
                  <button matChipRemove [attr.aria-label]="'remove ' + heatingItems">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #heatingInput [formControl]="heatCtrl" [matChipInputFor]="chipHeatingGrid"
                [matAutocomplete]="autoHeating" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addHeatingItems($event)" />
              <mat-autocomplete #autoHeating="matAutocomplete" (optionSelected)="selectedHeatingItems($event)">
                <mat-option *ngFor="let items of filteredHeatingItems | async" [value]="items">
                  {{items}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Cooling</mat-label>
              <mat-chip-grid #chipCoolingGrid aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let coolingItems of Cooling" (removed)="removeCoolingItems(coolingItems)">
                  {{coolingItems}}
                  <button matChipRemove [attr.aria-label]="'remove ' + coolingItems">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #coolingInput [formControl]="coolCtrl" [matChipInputFor]="chipCoolingGrid"
                [matAutocomplete]="autoCooling" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addCoolingItems($event)" />
              <mat-autocomplete #autoCooling="matAutocomplete" (optionSelected)="selectedCoolingItems($event)">
                <mat-option *ngFor="let items of filteredCoolingItems | async" [value]="items">
                  {{items}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Utilities</mat-label>
              <mat-chip-grid #chipUtilsGrid aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let utilItems of utils" (removed)="removeUtilItems(utilItems)">
                  {{utilItems}}
                  <button matChipRemove [attr.aria-label]="'remove ' + utilItems">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #utilInput [formControl]="utilCtrl" [matChipInputFor]="chipUtilsGrid"
                [matAutocomplete]="autoUtil" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addUtilItems($event)" />
              <mat-autocomplete #autoUtil="matAutocomplete" (optionSelected)="selectedUtilItems($event)">
                <mat-option *ngFor="let items of filteredUtilItems | async" [value]="items">
                  {{items}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field class="genericTextFiled_h60 other_rooms_chips" appearance="fill">
              <mat-label>Green Energy Generation</mat-label>
              <mat-chip-grid #chipEnergyGrid aria-label="Other rooms selection">
                <mat-chip-row *ngFor="let energyItems of energyGeneration" (removed)="removeEnergyItems(energyItems)">
                  {{energyItems}}
                  <button matChipRemove [attr.aria-label]="'remove ' + energyItems">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input placeholder="" #energyInput [formControl]="energyCtrl" [matChipInputFor]="chipEnergyGrid"
                [matAutocomplete]="autoEnergy" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="addEnergyItems($event)" />
              <mat-autocomplete #autoEnergy="matAutocomplete" (optionSelected)="selectedEnergyItems($event)">
                <mat-option *ngFor="let items of filteredEnergyItems | async" [value]="items">
                  {{items}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          
          <!-- <div class="submit_buttons">
            <p class="save_text" *ngIf="historyState.interiorData">
              <span class="check_icon"><img src="../../../assets/icons/check_green.svg" alt="done"></span>
              Saved
            </p>

            <div class="buttons">

              <button class="back_button" *ngIf="!isLoader" (click)="saveInteriorData()">Next</button>

              <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>

              <app-green-button-v2 (click)="saveInteriorData('submit')" label="Choose Plan"
                *ngIf="!isLoader && !historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

              <app-green-button-v2 (click)="saveInteriorData('submit')" label="Submit Listing"
                *ngIf="!isLoader && historyState.isPaymentDone" [buttonType]="'submit'" [width]="'166px'"
                [height]="'60px'">
              </app-green-button-v2>

            </div>
          </div> -->

          <div class="mobile_submitButtons">
            <button class="arrowBtn leftArrow" (click)="back()">
              <img src="../../../assets/icons/arrow_left_grey.svg" alt="arrow_left">
            </button>
            <app-green-button-v2 class="SumbitBtnRes"
              (click)="saveInteriorData(historyState.isPaymentDone ? 'submit' : 'skip')"
              [label]="historyState.isPaymentDone ? 'Submit Listing' : 'Choose Plan'" [buttonType]="'submit'"
              [width]="'136px'" [height]="'50px'">
            </app-green-button-v2>
            <app-loader class="loader_wrap" *ngIf="isLoader"></app-loader>
            <button (click)="saveInteriorData(null)" class="arrowBtn rightArrow">
              <img src="../../../assets/icons/arrow_right_grey.svg" alt="arrow-right">
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>